import { render, staticRenderFns } from "./PauseNoOk.vue?vue&type=template&id=45aaf990&scoped=true&"
import script from "./PauseNoOk.vue?vue&type=script&lang=js&"
export * from "./PauseNoOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aaf990",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45aaf990')) {
      api.createRecord('45aaf990', component.options)
    } else {
      api.reload('45aaf990', component.options)
    }
    module.hot.accept("./PauseNoOk.vue?vue&type=template&id=45aaf990&scoped=true&", function () {
      api.rerender('45aaf990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PauseNoOk.vue"
export default component.exports